import React from "react";
import Lottie from "lottie-react";
import FlymyaLoading from "../lotties/loading_animation.json";
import "../assets/tailwindcss/t-common-page.scss";

const FlymyaIconLoading = (props) => (
  <>
    <div className="t-loadingGifDiv fixed inset-0 z-[9999] flex flex-col justify-center items-center bg-black/30">
      <Lottie animationData={FlymyaLoading} loop={true} />
      {props?.loadingMessage && (
        <p className="text-[17px] text-white">{props?.loadingMessage}</p>
      )}
    </div>
  </>
);

export default FlymyaIconLoading;
